import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Alert,
} from '@mui/material';

interface ProjectResetDialogProps {
  open: boolean;
  projectName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ProjectResetDialog = ({ open, projectName, onClose, onConfirm }: ProjectResetDialogProps) => {
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = () => {
    if (confirmed) {
      onConfirm();
      setConfirmed(false); // Reset for next time
    }
  };

  const handleClose = () => {
    setConfirmed(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reset Project</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Are you sure you want to reset the project <strong>{projectName}</strong>?
          </Typography>
          <Typography variant="body2">
            This will reset all phases and tasks to their initial state. All historical data will be preserved for audit purposes.
          </Typography>
        </Alert>
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
            />
          }
          label="I understand this will reset the project"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={!confirmed}
        >
          Reset Project
        </Button>
      </DialogActions>
    </Dialog>
  );
};

